<template>
    <div>
<!--        <header-container :title="title" :showRefreshButton="showRefreshBtn" :showCloseButton="showCloseBtn" :onRefresh="refresh">-->
<!--            <template v-slot:button-left>-->
<!--                <slot name="toolButtons"></slot>-->
<!--            </template>-->
<!--        </header-container>-->
        <slot name="extensionInfo"></slot>
        <search-form class="search-form-card" :table-list="tableList" v-if="showSearchForm">
            <template v-slot:form-items>
                <slot name="searchForm"></slot>
            </template>
            <template v-slot:search-button-right>
                <slot name="toolButtons"></slot>
            </template>
            <template v-slot:bottom v-if="showTableStatement">
                <el-divider></el-divider>
                <div class="statement-info">
                    <slot name="tableStatement"></slot>
                </div>
            </template>
        </search-form>

        <div class="table-container">
            <div style="">
                <slot name="tableLeftSide"></slot>
            </div>
            <div style="flex:1; overflow-x: hidden; overflow-y: auto;">
                <permission-container :permissionId="tablePermissionId" showTip>
                    <el-table
                        @sort-change="handleTableSortChange"
                        v-loading="tableList.loading"
                        element-loading-background="rgba(0, 0, 0, 0.08)"
                        :data="tableList.data"
                        :border="border"
                        :stripe="stripe"
                        :style="tableStyle||'width: 100%'"
                        :row-class-name="rowClassName">
                        <slot name="tableColumns"></slot>
                    </el-table>
                    <div class="pagination-container">
                        <el-pagination
                            :small="true"
                            background
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="tableList.count"
                            :current-page.sync="tableList.page"
                            :page-size.sync="tableList.pageSize"
                            @size-change="handlePageSizeChange"
                            @current-change="handlePageChange"
                        >
                        </el-pagination>
                    </div>
                </permission-container>
            </div>
            <div style="">
                <slot name="tableRightSide"></slot>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: "PaginationTable",
    props: {
        title: {
            type: String,
            default: ''
        },
        tableList: Object,
        showCloseBtn: Boolean,
        showRefreshBtn: Boolean,
        tablePermissionId: String,
        rowClassName: Function,
        stripe: Boolean,
        border: Boolean,
        tableStyle: String,
        onRefresh: {
            type: Function,
            default : null
        },
        autoLoad:
        {
            type: Boolean,
            default: true
        },
        handleTableSortChange: {
            type: Function,
            default: ()=>null,
        },
    },
    data()
    {
        return {
            loading: true
        }
    },
    created()
    {
    },
    mounted()
    {
        if(this.autoLoad)
        {
            return this.load();
        }
    },
    methods:
    {
        onSubmit() {
            console.log('submit!', this.tableList);
            this.load();
        },
        handlePageSizeChange(val)
        {
            this.load();
        },
        handlePageChange(val)
        {
            this.load();
        },
        load()
        {
            this.loading = true;
            return this.tableList.load().catch(err=>console.log(err)).then(()=>this.loading=false);
        },
        refresh()
        {
            if(this.onRefresh)
            {
                return this.onRefresh();
            }
            else
            {
                return this.load();
            }
        },
        close()
        {
            this.$store.dispatch('layout/routeBack');
        }
    },
    computed:
    {
        showSearchForm()
        {
            return this.$slots.searchForm || this.$slots.toolButtons;
        },
        showTableStatement()
        {
            return this.$slots.tableStatement;
        }
    }
}
</script>
<style>
    .table-container .el-button {
        margin: 3px;
    }
</style>



// WEBPACK FOOTER //
// src/components/table/PaginationTable.vue